export default "__VITE_ASSET__XzlGIqSw__"